export const parseAppraiserInstructions = (appraiserInstructions: string) => appraiserInstructions
  .split(/\n/g).map((line) => {
    if (line.substring(0, 2) === '- ') {
      return `<div style="display: list-item; margin-left: 20px; margin-bottom: -20px;">${line.replace('- ', '')}</div>`;
    }
    return line;
  })
  .join('\n')
  .replace(/\n|\r\n|\r/g, '<br/>')
  .replace(/\*\*(.*?)\*\*/g, '<span style="font-weight: bold;">$1</span>')
  .replace(/\*(.*?)\*/g, '<span style="font-style: italic;">$1</span>');
